import { Autocomplete, Box, TextField, ThemeProvider, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import customTheme from '../lib/customTheme';
import mobile from '../lib/mobile';

const SelectActividad = ({ onSelect = () => { } }) => {
    // const outerTheme = useTheme();
    const [catalogoActividades, setCatalogoActividades] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const getCatalogo = async () => {

        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/catalogo_actividades`)
            .then((res) => res.json())
            .then((respuesta) => {
                setCatalogoActividades(respuesta.data);
            })
    }

    useEffect(() => {
        getCatalogo();
        setIsMobile(mobile());
    }, []);

    return (
        <Box>
            {/* <ThemeProvider
                theme={customTheme(outerTheme)}
            > */}
            <Autocomplete
                onChange={(e, newVal) => onSelect(newVal)}
                disablePortal
                options={catalogoActividades}
                getOptionLabel={(option) => option.nombre_act ?? ''}
                sx={{
                    width: isMobile ? '100%' : 300,
                }}
                renderInput={(params) =>
                    <TextField variant="standard" {...params} label="Giro de actividad económica" />
                }
            />
            {/* <Autocomplete
                        fullWidth
                        disableClearable
                        name="giro_actividad"
                        options={catalogoActividades}
                        getOptionLabel={(option) => option.nombre_act ?? ''}
                        value={giroSeleccionado}
                        onChange={(e, actividad) => {
                            handleGiros(actividad);
                            setGiroSeleccionado(actividad.codigo_act);
                        }}
                        renderInput={params => (
                            <TextField {...params} label="Giro de actividad económica" />
                        )}
                    /> */}
            {/* </ThemeProvider> */}
        </Box>
    )
}

export default SelectActividad